import {action, makeObservable, observable, runInAction} from "mobx";
import ToasterStore from "./ToasterStore";
import LayoutStore from "./LayoutStore";
import axios from "axios";
import {GET_ADDRESSES} from "../graphql/Queries";

const LANG = process.env.REACT_APP_LANG;
const API_BASE = (LANG === 'tr') ? (process.env.REACT_APP_API_BASE_TR) : (process.env.REACT_APP_API_BASE_EN);

class AddressStore {
  loading = false;
  addresses=[];

  constructor() {
    makeObservable(this, {
      loading: observable,
      addresses:observable,
      getAddresses: action,
    });
  }

  async getAddresses(type){
    try {
      runInAction(() => {
        this.loading = true;
      });
      const account = LayoutStore.accountId;
      if (!account) {
        runInAction(() => {
          this.loading = false;
        });
        ToasterStore.pushMessage({type: "error", body: "Error while fetching account"});
      }
      const {data} = await axios({
        url: `${API_BASE}`,
        method: 'post',
        headers: {
          "Authorization": `${LayoutStore.token}`
        },
        data: {
          query: `{${GET_ADDRESSES(type)}}`
        }
      });
      runInAction(() => {
        this.loading = false;
      });
      if (data.errors) {
        data.errors.map((error) => {
          ToasterStore.pushMessage({type: "error", body: error.message});
        });
        return false;
      }
      this.addresses = data.data.addresses;
    }catch (e) {
      runInAction(() => {
        this.loading = false;
      });
      ToasterStore.pushMessage({type: "error", body: e.message.toString()});
    }
  }
}
export default new AddressStore();
